<template>
    <div class="exam__item" :class="{
        'exam-free': exam.price === 0,
        'exam-price': exam.price > 0,
    }">
        <h4 class="exam__item__title">
            <b-link
            :to="{
                name: 'exam-detail',
                params: { id: exam.id, slug: exam.slug }
            }"
            :title="exam.description"
            >{{ exam.name }}</b-link
            >
        </h4>
        <div class="exam__item__time">
            <img src="@/assets/images/time-23.svg" width="30px" alt="time hsk" />
            <span>{{ exam.time }} phút</span>
        </div>

        <b-link
            :to="{
            name: 'exam-detail',
            params: { id: exam.id, slug: exam.slug }
            }"
            class="exam__item__btn"
            >Xem chi tiết</b-link
        >
    </div>
  </template>
  
  <script>
  export default {
    props: ['exam'],
    mounted() {},
  }
  </script>
  
<style scoped>
.exam-free {
    position: relative;
    /* background: #f0f8ff6e; */
}
.exam-free::after {
    /* content: '\1F381'; */
    position: absolute;
    top: 0px;
    right: 5px;
    font-size: 20px;
}
.exam__item__time {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}
</style>